import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationKeys } from './useNotifications';
import { notificationRepository } from '../../infrastructure/repositories';
import type { MarkNotificationsReadRequest } from '../../domain/types';

export function useMarkNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: MarkNotificationsReadRequest) => notificationRepository.markRead(request),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: notificationKeys.all }),
  });
}
